// services/product-service.js

import axios from "axios";
import authHeader from "../../../helpers/jwt-token-access/auth-token-header";
import { GetQueryParam } from "../../../helpers/general/generalHelpers";
import { appConfig } from "../../../config/config";

function saveProduct(values) {
  const productId = GetQueryParam(window.location.search, "id");
  let requestType = "put";
  let url = "/products/" + productId;
  if (!productId) {
    requestType = "post";
    url = "/products";
  }
  return axios[requestType](`${url}`, values, { headers: authHeader() });
}

function deleteProduct(productId) {
  return axios.delete(`/products/${productId}`, {
    headers: authHeader(),
  });
}

function getProducts(pageNumber = 1, pageSize = appConfig.RecordsPerPage) {
  return axios.get(
    `/products?pageNumber=${pageNumber}&pageSize=${pageSize}`,
    { headers: authHeader() }
  );
}

function getProduct(id) {
  return axios.get(`/products/${id}`, {
    headers: authHeader(),
  });
}

function getAllSubjects() {
  return axios.get(`/subject?pageSize=1000`, { headers: authHeader() });
}

function getAllRoles() {
  return axios.get(`/role?pageSize=1000`, { headers: authHeader() });
}

function getGrantablePermissions() {
  return axios.get(`/roleroute?isGrantable=true`, { headers: authHeader() });
}


export { saveProduct, getProducts, getProduct, deleteProduct, getAllSubjects, getAllRoles, getGrantablePermissions };